export default __webpack_public_path__ + "static/media/iconHyphen.17a319c8.svg";